/**
 * FikoYT UI — @fikoyt/shared kütüphanesine taşınan ortak çekirdek.
 *
 * NOT: Bu çekirdek, fikoyt-sistem'e özel BAĞIMLILIĞI OLMAYAN
 * (decorators, directives, extensions, helpers, interfaces, pipes,
 * services ve dinamik-bilesen çekirdeği) modülleri dışa açar.
 *
 * paylasim-sistemi ve fiko-three-js gibi uygulama-özel bağımlılığı
 * olan modüller BİLİNÇLİ olarak buradan dışarıda bırakıldı.
 */

// Decorators
export * from '../decorators/debounce';
export * from '../decorators/dinamik-bilesen';

// Directives
export * from '../directives/zamanliGoster.directive';

// Extensions & Helpers
export * from '../extensions/extensions';
export * from '../helpers/FikoYTId';
export * from '../helpers/durations';

// Interfaces (uygulama-özel bağımlılığı olmayanlar)
export * from '../interfaces/IAlan';
export * from '../interfaces/IDinamikBilesen.interface';
export * from '../interfaces/IGrup';
export * from '../interfaces/IKart.interface';
// IParametre üst dosyası kendi tip setini içerir;
// alt IParametre/IParametre.ts ile name çakışmasını önlemek için sadece üstü açıyoruz.
export * from '../interfaces/IParametre';
// IParametreSeti.interface paylaşım sistemine (ISablon) bağımlıdır; kapsam dışı.

// Pipes
export * from '../pipes/dosya-boyutu.pipe';
export * from '../pipes/filoyt-uzun-bas.pipe';
export * from '../pipes/onInit.pipe';
export * from '../pipes/sanitize.pipe';
export * from '../pipes/yuvarla.pipe';

// Services
export * from '../services/asset-loader.service';

// Dinamik Bileşen çekirdeği
export * from './lib/dinamik-bilesen';

// Uygulama Başlık Bileşeni
export * from './lib/fikoyt-uygulama-baslik/fikoyt-uygulama-baslik.component';
export * from './lib/fikoyt-uygulama-baslik/baslik-portal.service';

// Kullanıcı Menü Bileşeni
export * from './lib/fikoyt-diyalog-kullanici-menu/fikoyt-diyalog-kullanici-menu.component';
